module.exports = __webpack_public_path__ + "static/media/hwi2.b432125c.webp";